<sf-form-element-action
  *ngFor="let button of buttons"
  [button]="button"
  [formProperty]="formProperty">
</sf-form-element-action>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/buttongroup.widget.html